import {
  AppDispatch,
  getChildOrganizationListRequest,
  getClientOrganizationListRequest,
  getOrganizationListRequest,
  unarchiveOrganization,
  unarchiveOrganizationClear,
  unarchiveOrganizationRequest,
  useDynamicSelector,
} from "@src/redux";
import { Button } from "antd";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

interface UnArchiveCardProps {
  name: string;
  onCancel: () => void;
  worker: {
    name: string;
    id: string;
  };
}

const UnArchiveCard: React.FC<UnArchiveCardProps> = ({
  worker,
  name,
  onCancel,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { result: unArchiveResult, loading: unArchiveLoading } =
    useSelector(unarchiveOrganization);
  const { id } = useParams();
  const { filter: clientFilter } = useDynamicSelector("client_filter");
  const { pathname } = useLocation();

  useEffect(() => {
    if (unArchiveResult?.status === "success") {
      toast.success(t("unarchive_successfully", { name: name }));
      dispatch(unarchiveOrganizationClear());
      onCancel();
      if (!pathname.includes("clients")) {
        dispatch(
          getChildOrganizationListRequest({
            filter: {
              parentOrganizationId: id || "",
            },
            pagination: {
              pageLimit: 10,
              pageNumber: 1,
            },
          })
        );
      } else {
        dispatch(
          getClientOrganizationListRequest({
            ...clientFilter,
            pagination: { pageLimit: 10, pageNumber: 1 },
            sort: [
              {
                field: "name",
                order: "asc",
              },
            ],
          })
        );
      }
    }
  }, [unArchiveResult?.status]);

  const onUnArchiveClick = () => {
    dispatch(
      unarchiveOrganizationRequest({
        id: worker?.id || "",
      })
    );
  };

  return (
    <div>
      <span>{`Are you sure you want to Un Archive the "${name}"?`}</span>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Button style={{ marginRight: "10px" }} onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          type="primary"
          onClick={onUnArchiveClick}
          loading={unArchiveLoading}
        >
          {t("un_archive")}
        </Button>
      </div>
    </div>
  );
};

export default UnArchiveCard;
